<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../../map/common/businessEchartBmap/index';
    import mapPropsMinxin from './default-props-value';
    import PolygonOverlay from './../common/inMapOverlay/AbstractPolygon';
    import loaderData from './loaderData.js';
    const axios = require('axios');
    import {
        colToRow,
        rowsToGeo
    } from './../../../lib/utils';
    export default {
        name: '',
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            const cacheData = {
                polygonOverlay: null
            };
            return {
                timer: null,
                getCacheData() {
                    return cacheData;
                },

                setValues: []
            }
        },
        watch: {
            api(newVal, oldVal) {
                
                if (oldVal != newVal) {
                    this.ajaxData();
                }

            },
            name(newVal, oldVal) {
              
              
                if (oldVal != newVal) {
                    this._loadData();
                }

            },
            isTooltip() {
                this._updateOption();
            },
            isLegend() {
                this._updateOption();
            },
            legendTitle() {
                this._updateOption();
            },
            isAutoColor() {
                this._updateOption();
            },
            // borderStyle() {
            //     this._updateOption();
            // },
            // borderWidth() {
            //     this._updateOption();
            // },
            isLabel() {
                this._updateOption();
            },
            opacity() {
                const polygonOverlay = this.getCacheData().polygonOverlay;
                if (polygonOverlay) {
                    polygonOverlay.clearSplitList();
                }
                // console.log('---opacity',this.opacity);
                this._updateOption();
            }
            // labelColor() {
            //     this._updateOption();
            // },
            // mouseOverLabelColor() {
            //     this._updateOption();
            // },
            // backgroundColor() {
            //     this._updateOption();
            // },
            // mouseOverBackgroundColor() {
            //     this._updateOption();
            // },
            // selectedBackgroundColor() {
            //     this._updateOption();
            // },
            // selectedBorderColor() {
            //     this._updateOption();
            // },
            // selectedLableColor() {
            //     this._updateOption();
            // }

        },
        computed: {

        },
        methods: {
            colors() {
                return [
                    `rgba(0, 184, 255,${this.opacity})`,
                    `rgba(72, 246, 217,${this.opacity})`,
                    `rgba(252, 196, 95,${this.opacity})`,
                    `rgba(255, 132, 84,${this.opacity})`,
                    `rgba(219, 66, 90,${this.opacity})`
                ];
            },
            _updateOption() {
                const polygonOverlay = this.getCacheData().polygonOverlay;
                if (polygonOverlay) {
                    if (this.timer) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.timer = setTimeout(() => {
                        polygonOverlay.setOptionStyle(this._getOptions());
                    }, 1000);
                }
            },
            _initMap() {
                const mapComponent = this.$refs.map.getMapComponent();

                const polygonOverlay = new PolygonOverlay(this._getOptions());
                mapComponent.addInMapOverlay(polygonOverlay);
                this.getCacheData().polygonOverlay = polygonOverlay;
               
            },
            _loadData() {
             
                loaderData(this.name).then((data) => {

                    const polygonOverlay = this.getCacheData().polygonOverlay;
                    polygonOverlay.setPolygonData(data);
                    polygonOverlay.setValue(this.setValues);
                    // let d=data.map((item,index)=>{
                    //     return [item.name,index]
                    // });
                    // console.log(this.name,JSON.stringify(d));
                });
            },
            _getOptions() {

                let option = {
                    tooltip: {
                        show: this.isTooltip,
                        formatter: this.tooltip
                    },
                    legend: {
                        show: this.isLegend,
                        title: this.legendTitle
                    },
                    style: {
                        normal: {
                            borderWidth: 0.5,
                            label: {
                                show: this.isLabel, // 是否显示
                                font: "13px bold ",
                                color: "#fff"
                            }
                        },
                        mouseOver: {
                            shadowColor: "rgba(0, 0, 0, 1)",
                            shadowBlur: 10,
                            borderWidth: 1.5,
                            label: {
                                color: "rgba(0, 0, 0, 1)"
                            }
                        },
                        selected: {
                            backgroundColor: "rgba(184,0,0,1)",
                            borderColor: "rgba(255,255,255,1)",
                            borderWidth: 2,
                            label: {
                                color: "rgba(255,255,255,1)"
                            }
                        },
                        colors: this.isAutoColor ? this.colors() : []
                    }
                }
                return option;
            },
            ajaxData() {
                if (this.api == "") return;
                  
                axios.get(this.api)
                    .then((response) => {
                        const data = response.data;
                        const rows = colToRow(data);
                        this.setValues = rows || [];
                        const polygonOverlay = this.getCacheData().polygonOverlay;
                        polygonOverlay.clearSplitList();
                        polygonOverlay.setValue(this.setValues);
                    });
            },
            mapLoad() {
                this._initMap();
                // this.ajaxData();
            },
            resize() {
                this.$refs.map.resize();
            }
        },
        mounted() {

        }
    }
</script>